/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_data_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your plan is almost certainly advertised in megabits per second (Mbps), while file transfer progress bars usually show megabytes per second (MB/s). Since 1 byte is 8 bits, a 100 Mbps connection tops out around 12.5 MB/s — dividing the advertised number by 8 gives a realistic download speed estimate.`)
};

const es_uc_data_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu plan es casi ciertamente anunciado en megabits por segundo (Mbps), mientras que las barras de progreso de transferencia de archivos generalmente muestran megabytes por segundo (MB/s). Porque 1 byte es 8 bits, una conexión de 100 Mbps llega a aproximadamente 12.5 MB/s — dividir el número anunciado por 8 da una estimación realista de velocidad de descarga.`)
};

const de_uc_data_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Tarif wird mit ziemlicher Sicherheit in Megabit pro Sekunde (Mbps) beworben, während Fortschrittsbalken bei Dateiübertragungen meist Megabyte pro Sekunde (MB/s) anzeigen. Da 1 Byte 8 Bit sind, erreicht eine 100-Mbps-Verbindung höchstens etwa 12.5 MB/s — teilen Sie die beworbene Zahl durch 8, um eine realistische Download-Geschwindigkeit zu schätzen.`)
};

const nl_uc_data_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uw plan is bijna zeker geadverteerd in megabits per seconde (Mbps), terwijl voortgangsstaven van bestandsoverdracht meestal megabytes per seconde (MB/s) tonen. Omdat 1 byte 8 bits is, een 100 Mbps verbinding maxes rond 12.5 MB/s — dividing het geadverteerde getal door 8 geeft een realistische downloadsnelheid-schatting.`)
};

const fr_uc_data_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre plan est presque certainement annoncé en mégabits par seconde (Mbps), tandis que les barres de progression de transfert de fichiers affichent généralement les mégaoctets par seconde (MB/s). Puisqu'1 octet est 8 bits, une connexion 100 Mbps culmine autour de 12,5 MB/s — diviser le nombre annoncé par 8 donne une estimation réaliste de vitesse de téléchargement.`)
};

const it_uc_data_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo piano è quasi certamente pubblicizzato in megabit al secondo (Mbps), mentre le barre di progresso del trasferimento di file di solito mostrano megabyte al secondo (MB/s). Poiché 1 byte è 8 bit, una connessione 100 Mbps raggiunge circa 12,5 MB/s — dividendo il numero pubblicizzato per 8 dà una stima realistica della velocità di download.`)
};

const pt_br2_uc_data_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu plano é quase certamente anunciado em megabits por segundo (Mbps), enquanto barras de progresso de transferência de arquivo geralmente mostram megabytes por segundo (MB/s). Como 1 byte são 8 bits, uma conexão de 100 Mbps máxima em cerca de 12.5 MB/s — dividir o número anunciado por 8 dá uma estimativa realista de velocidade de download.`)
};

const pt_uc_data_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O seu plano é quase certamente anunciado em megabits por segundo (Mbps), enquanto as barras de progresso de transferência de ficheiro geralmente mostram megabytes por segundo (MB/s). Como 1 byte é 8 bits, uma ligação de 100 Mbps máximos de cerca de 12,5 MB/s — dividir o número anunciado por 8 dá uma estimativa de velocidade de transferência realista.`)
};

const ja_uc_data_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたのプランはほぼ確実にメガビット毎秒(Mbps)で宣伝され、ファイル転送プログレスバーはメガバイト毎秒(MB/s)を示しています。1バイトは8ビットで、100 Mbps 接続は約12.5 MB/s で頭打ちに — 宣伝される数を8で除くことは現実的なダウンロード速度見積もりを与えます。`)
};

const zh_uc_data_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_data_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_data_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_data_faq4_a", locale)
	if (locale === "en") return en_uc_data_faq4_a(inputs)
	if (locale === "es") return es_uc_data_faq4_a(inputs)
	if (locale === "de") return de_uc_data_faq4_a(inputs)
	if (locale === "nl") return nl_uc_data_faq4_a(inputs)
	if (locale === "fr") return fr_uc_data_faq4_a(inputs)
	if (locale === "it") return it_uc_data_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_data_faq4_a(inputs)
	if (locale === "pt") return pt_uc_data_faq4_a(inputs)
	if (locale === "ja") return ja_uc_data_faq4_a(inputs)
	return zh_uc_data_faq4_a(inputs)
};